import { render } from "./ParametrosContabilizacion.vue?vue&type=template&id=1cd24ef7&scoped=true"
import script from "./ParametrosContabilizacion.vue?vue&type=script&lang=js"
export * from "./ParametrosContabilizacion.vue?vue&type=script&lang=js"

import "./ParametrosContabilizacion.vue?vue&type=style&index=0&id=1cd24ef7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd24ef7"]])

export default __exports__